// Q2 / Q12 自由記述
import { TextField, makeStyles } from "@material-ui/core";
import * as React from "react";

const useStyles = makeStyles(() => ({
  freeText: {
    width: "100%",
    marginTop: 16,
    "& .MuiOutlinedInput-root": { minHeight: 144 },
  },
}));

type FreeTextProps = {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  ariaLabel?: string;
};
export const DiagnosisInvestmentStyleFreeText: React.FC<FreeTextProps> = ({ value, placeholder, onChange, ariaLabel = "プランナーに伝えておきたいこと" }) => {
  const classes = useStyles();
  return (
    <TextField
      className={classes.freeText}
      inputProps={{ "aria-label": ariaLabel }}
      multiline
      minRows={4}
      variant="outlined"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};
